import { FeatureFlagName } from "../enums/feature-flags";
export const REPEAT_DONOR_TIP_EXPERIMENT_HIGH_AMOUNT_THRESHOLD_IN_CENTS = 25_000;
export const REPEAT_DONOR_TIPPED_UI_EXPERIMENT_NAME = FeatureFlagName.RepeatDonorTippedLastDonationUiV1;
export const REPEAT_DONOR_LOW_TIP_OVER_250_EXPERIMENT_NAME = FeatureFlagName.RepeatDonorLowTipOver250V1;
export const REPEAT_DONOR_TIP_EXPERIMENT_NAMES = [
    FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Under250,
    FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Over250,
    REPEAT_DONOR_TIPPED_UI_EXPERIMENT_NAME,
    REPEAT_DONOR_LOW_TIP_OVER_250_EXPERIMENT_NAME,
];
export const getRepeatDonorTipExperimentName = (amountInCents) => amountInCents < REPEAT_DONOR_TIP_EXPERIMENT_HIGH_AMOUNT_THRESHOLD_IN_CENTS
    ? FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Under250
    : FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Over250;
export const isRepeatDonorTipExperimentName = (name) => REPEAT_DONOR_TIP_EXPERIMENT_NAMES.some((experimentName) => experimentName === name);
